// extracted by mini-css-extract-plugin
export default {"container":"CpsPincodeModal_container__LYR9y","loader":"CpsPincodeModal_loader__cHLhx"};